module.exports = __webpack_public_path__ + "img/fskMS.bd5e51af.png";